module.exports = ".modal-title{\n    font-size: 16px;\n    text-transform: uppercase;\n    font-family: Montserrat-Bold;\n    color: #062b3e;\n    text-align: center;\n}\n\n.no-slots-error {\n    color: red;\n    font-size: 14px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/schedule-call/schedule-call.component.css
// module id = ./src/app/shared/components/schedule-call/schedule-call.component.css
// module chunks = main